import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';
import TextBase from '@components/common/core/DataDisplay/Text';
import InputGroupBase from '@components/common/core/Inputs/InputGroup';
import TextFieldBase from '@components/common/core/Inputs/TextField';
import LabelBase from '@components/common/core/DataDisplay/Label';
import ButtonBase from '@components/common/core/Inputs/Button';
import SelectBase from '@components/common/core/Inputs/Select';
import OptionBase from '@components/common/core/Inputs/Select/Option';

export const Option = styled(OptionBase)``;

export const Select = styled(SelectBase)`
  width: 100%;
`;

export const NextStepButton = styled(ButtonBase)`
  width: 100%;
`;

export const NumberAndComplementaryWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  & > div:first-child {
    max-width: 84px;
  }
`;

export const CityAndStateWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
`;

export const Input = styled(TextFieldBase)``;

export const Label = styled(LabelBase)``;

export const InputGroup = styled(InputGroupBase)`
  margin: unset;
`;

export const FormContent = styled.div`
  & > div {
    margin-bottom: 24px;
  }

  & > div:last-of-type {
    margin-bottom: 32px;
  }
`;

export const StepNumber = styled(TextBase)`
  font-size: 1.25rem;
  font-weight: 700;
`;

export const StepNumberWrapper = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.gray[6]};
`;

export const Title = styled(HeadingBase)``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
`;

export const Wrapper = styled.div`
  @media only screen and (max-width: 450px) {
    padding: 0 32px;
  }
`;
